import loadable from '@loadable/component';
import { WithLazyHydration } from '../../WithLazyHydration';

const YoutubeVideoParagraphLoadable = loadable(
  () => import('./YoutubeVideoParagraph'),
  {
    resolveComponent: components => components.YoutubeVideoParagraph
  }
);

export const YoutubeVideoParagraph = WithLazyHydration(
  YoutubeVideoParagraphLoadable,
  {
    name: 'YoutubeVideoParagraph'
  }
);
